import styled from '@emotion/styled'

export const Container = styled.div`
	border-radius: 12px;
	display: flex;
	gap: 3px;
	min-height: 12px;
	overflow: hidden;
`

export const Bar = styled.div`
	overflow: hidden;
`

export const InnerBar = styled.div`
	border-radius: 10px;
	height: 8px;
	margin: 2px;
`
